/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Sociaal_Emotionele_ResultatenInputs */

const nl_rapporten_config_elements_sociaal_emotionele_resultaten = /** @type {(inputs: Rapporten_Config_Elements_Sociaal_Emotionele_ResultatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociaal-emotionele resultaten`)
};

/**

* @param {Rapporten_Config_Elements_Sociaal_Emotionele_ResultatenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_sociaal_emotionele_resultaten = /** @type {((inputs?: Rapporten_Config_Elements_Sociaal_Emotionele_ResultatenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Sociaal_Emotionele_ResultatenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_sociaal_emotionele_resultaten(inputs)
});
export { rapporten_config_elements_sociaal_emotionele_resultaten as "rapporten.config.elements.sociaal_emotionele_resultaten" }